module.exports = __webpack_public_path__ + "img/4-3.2a8bff0f.png";